import { useMemo } from "react";
import "./highlightText.css";

function escapeRegExp(value) {
  return value.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
}

/**
 * Wrap query matches in a yellow marker <mark>.
 * Optional — when query is empty, renders plain text.
 */
export default function HighlightText({ text, query }) {
  const value = text == null ? "" : String(text);

  const nodes = useMemo(() => {
    if (!value) return null;

    const raw = (query || "").trim();
    if (!raw) return value;

    const tokens = [
      ...new Set(
        raw
          .split(/\s+/)
          .map((t) => t.trim())
          .filter((t) => t.length >= 2),
      ),
    ].sort((a, b) => b.length - a.length);

    if (!tokens.length) return value;

    let pattern;
    try {
      pattern = new RegExp(`(${tokens.map(escapeRegExp).join("|")})`, "gi");
    } catch {
      return value;
    }

    const parts = value.split(pattern);
    const lowerTokens = new Set(tokens.map((t) => t.toLowerCase()));

    return parts.map((part, index) => {
      if (!part) return null;
      if (lowerTokens.has(part.toLowerCase())) {
        return (
          <mark key={`m-${index}`} className="text-mark">
            {part}
          </mark>
        );
      }
      return <span key={`t-${index}`}>{part}</span>;
    });
  }, [value, query]);

  if (nodes == null) return null;
  return <>{nodes}</>;
}
